export default (theme) => ({
  title: {
    fontSize: '22px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: 10,
  },
  subheader: {
    color: '#646262',
    marginBottom: 5,
  },
  avatar: {
    display: 'inline-block',
    paddingLeft: 10
  },
  textContainer: {
    display: 'inline-block',
    paddingLeft: 20,
    verticalAlign: 'top'
  },
  name: {
    fontSize: '20px',
    //marginBottom: 5,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  icon: {
    height: '15px',
    marginRight: 5
  },
  contactDetails: {
    marginBottom: 5,
    fontSize: '13px'
  },
  facebookButton: {
    color: '#4267B2'
  },
  linkedInButton: {
    color: '#2867B2'
  },
  twitterButton: {
    color: '#1DA1F2'
  },
  iconButton: {
    padding: 7
  },
  leader: {
    position: 'relative'
  },
  socialIcons: {
    position: 'absolute',
    left: 160,
    bottom: 5
  }
});
